export const zIndexes = {
  footer: 20,
  header: 10,
  loading: 50,
  modal: 30,
  navigation: 15,
};

export default zIndexes;
